import { Grid, TextField } from '@mui/material';
import { useStyles } from './styles/FormTextArea.styles';

import type { Dispatch, SetStateAction } from 'react';

type FormTextAreaProps<State extends Record<any, any>> = {
    draft: [State, Dispatch<SetStateAction<State>>];
    stateKey: keyof State;
    helperText?: string;
    placeholder?: string;
    rows?: number;
};

export const FormTextArea = <State extends Record<any, any>>({
    draft,
    stateKey,
    helperText,
    placeholder,
    rows = 10,
}: FormTextAreaProps<State>) => {
    const classes = useStyles();
    const [state, setState] = draft;

    return (
        <Grid item xs={12} md={12} className={classes.wrapper}>
            <TextField
                placeholder={placeholder}
                error={false}
                onChange={(e) => setState((prev) => ({ ...prev, [stateKey]: e.target.value }))}
                value={state[stateKey]}
                className={classes.input}
                multiline
                helperText={helperText}
                fullWidth
                rows={rows}
            />
        </Grid>
    );
};
